import script from "./VTableTr.vue?vue&type=script&setup=true&lang=js"
export * from "./VTableTr.vue?vue&type=script&setup=true&lang=js"

import "./VTableTr.vue?vue&type=style&index=0&id=13381230&scoped=true&lang=less"

import exportComponent from "D:\\cwzl\\cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13381230"]])

export default __exports__